module.exports = __webpack_public_path__ + "static/material-table-selected-row-c52f80a53fd0e435a0b4a3c3f44391fd.png";